export const STUDIES = [
  {
    "Title": "Lithium Urban Technologies",
    "Descriptions": "Replace privately owned commuting vehicles with shared vehicle service to pick up workers from their location of choice, deliver them home at the end of the day, and make trips during the day.",
    "NMT, MOD": 0,
    "Shared Mobility": 0.4444444444,
    "Public Transit": 0,
    "EV Public": 0.3333333333,
    "EVs, Private": 0.2222222222,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Ecocabs: Rickshaw on Demand",
    "Descriptions": "Establish a network of call centers to organize the cycle rickshaw transport system.",
    "NMT, MOD": 0.3333333333,
    "Shared Mobility": 0.3333333333,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0.3333333333,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Bay Area Commuter Benefits Program",
    "Descriptions": "Create policy requirements and tax advantages for companies over a certain size to provide incentives for employees to use commuting options other than private vehicles.",
    "NMT, MOD": 0.09090909091,
    "Shared Mobility": 0.3636363636,
    "Public Transit": 0.2727272727,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0.2727272727,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Oslo Electric Vehicle Charging Expansion",
    "Descriptions": "Deploy electric vehicle supply equipment across cities to promote electric vehicle uptake. Offer incentives such as free parking and vehicle charging and switch government vehicle fleets to EVs.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0.5,
    "EVs, Private": 0.5,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Blue LA Shared EVs",
    "Descriptions": "Provide shared electric vehicles in neighborhoods to reduce personal vehicles, increase ease of transport, and increase transport equity.",
    "NMT, MOD": 0,
    "Shared Mobility": 0.5,
    "Public Transit": 0,
    "EV Public": 0.5,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Mumbai Bus Electrification",
    "Descriptions": "Replace diesel or natural gas-powered public transit buses with electric buses or hybrid electric buses.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0.2727272727,
    "EV Public": 0.3636363636,
    "EVs, Private": 0,
    "BRT?": 0.3636363636,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Green Raiteros",
    "Descriptions": "Establish a formal ride-share system to connect isolated and distant rural areas to critical services available only in the city. Use a professional centralized dispatching service to manage and support the network.",
    "NMT, MOD": 0,
    "Shared Mobility": 0.5714285714,
    "Public Transit": 0,
    "EV Public": 0.4285714286,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Pune Bicycle Plan",
    "Descriptions": "Promote and deploy affordable bike sharing in the city to improve last mile connectivity and city mobility.",
    "NMT, MOD": 0.6666666667,
    "Shared Mobility": 0.3333333333,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "BMR Van Transit",
    "Descriptions": "Operate a series of privately owned, privately operated vans serve as public transit on public streets and mixed traffic expressways.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0.5,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0.5,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Ahmedabad Bus Rapid Transit",
    "Descriptions": "Create dedicated lane systems for bus rapid transit systems to allow faster commuting, and integrate this with last mile transit options, existing urban planning infrastructure, and citizen involvement campaigns.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0.5,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0.5,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Three Wheels United",
    "Descriptions": "Support auto rickshaw drivers%u2019 financial stability and independence through facilitating financial loans to purchase an auto rickshaw.",
    "NMT, MOD": 0,
    "Shared Mobility": 0.5,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0.5,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Raaghiri Day",
    "Descriptions": "Once a week, open certain city streets in the city center to walking, cycling, and other non-motorized transit only, and host a variety of community events, vendors, and various other activities to foster community inclusiveness.",
    "NMT, MOD": 0.5714285714,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0.1428571429,
    "Citizen Welfare & Access": 0.2857142857,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Project Tender S.U.R.E.",
    "Descriptions": "Develop and implement a standard for long-term urban road infrastructure to meet the needs of all its users, including pedestrians, cyclists, and street vendors.",
    "NMT, MOD": 1,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "HP Junction and Installation",
    "Descriptions": "Organize intersections/junctions to make them more pedestrian friendly by creating temporary installations with paint and barriers that demarcate space for both vehicles and pedestrians.",
    "NMT, MOD": 1,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Complete Streets",
    "Descriptions": "Transform streetscapes to incorporate features such as protected footpaths, pedestrian plazas, priority zones, and cycle lanes to promote non-motorized transit.",
    "NMT, MOD": 1,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Sustainable Mobility Project 2.0 - Bangkok",
    "Descriptions": "Employ a traffic management model to reduce road congestion, travel time, and environmental pollution.",
    "NMT, MOD": 0,
    "Shared Mobility": 0.1,
    "Public Transit": 0.1,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0.4,
    "Citizen Welfare & Access": 0,
    "Data": 0.4,
    "Freight": 0
  },
  {
    "Title": "Jamshedpur Color-Coded Parking Policy",
    "Descriptions": "Regulate parking and help streamline traffic in major central and commercial corridors and hubs of urban areas.",
    "NMT, MOD": 0.2,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0.8,
    "Citizen Welfare & Access": 0,
    "Data": 0,
    "Freight": 0
  },
  {
    "Title": "Singapore Electronic Road Pricing",
    "Descriptions": "Employ a traffic management and decongestion system such as electronic road pricing to disincentivize use of private vehicles by charging drivers based on peak and non-peak traffic hours.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0.5,
    "Citizen Welfare & Access": 0,
    "Data": 0.5,
    "Freight": 0
  },
  {
    "Title": "Locus",
    "Descriptions": "Leverage technology and optimization algorithms to provide efficient, consistent, and transparent logistics operations and management for freight.",
    "NMT, MOD": 0,
    "Shared Mobility": 0,
    "Public Transit": 0,
    "EV Public": 0,
    "EVs, Private": 0,
    "BRT?": 0,
    "Traffic": 0,
    "Citizen Welfare & Access": 0,
    "Data": 0.5,
    "Freight": 0.5
  }
];



// WEBPACK FOOTER //
// ./src/data/caseStudies.js